//This component show the datatable, need to redo this to make the table dynamic / need to Refactor this code
import "../css/Table.css";
import React from "react";
 
import {  Table, Tabs, Card, Tag, Badge,Modal,List,Button,Avatar,message,Typography,Statistic,Tooltip,Input } from "antd";
import { CSVLink, CSVDownload } from "react-csv";
import reqwest from "reqwest";
import { connect } from "react-redux";
import axios from 'axios';
import { PlusCircleTwoTone,CheckCircleTwoTone,PlusOutlined,RightSquareFilled,DollarOutlined,ExclamationCircleOutlined } from "@ant-design/icons";
import { Link } from 'react-router-dom'
//import {Badge   } from "@ant-design/icons";
import {
  activateDatadic,
  activatePath,
  activateStocks,
  activateRecord,
  activateTablehead,
  activateRecordtb,
  activateScreen,
} from "../redux";
const { TabPane } = Tabs;
const { confirm } = Modal;
function setI(a, b, sortOrder) {
  if (sortOrder == "ascend") {
    if (b == "None" || b == "") {
      return -8888888;
    } else {
      return b - a;
    }
  }
  if (sortOrder == "descend") {
    if (a == "None" || a == "") {
      return 888888;
    } else {
      return b - a;
    }
  }
}

function setnull(a,sortOrder) {
  //console.log(sortOrder)
  var cop=0;
  if (sortOrder=="descend"){
    cop=-9999
  }else if (sortOrder=="ascend"){
    cop=999999999999
  }else{
cop=-999999;
  }
  if (a == null) {
    return cop;
  } else if (a == "None") {
    return cop;
  } else if (a == "na") {
    return cop;
  } else if (a == "") {
    return cop;
  } else {
    return a;
  }
}

function setnullZero(a,sortOrder) {
  var cop=0;
  if (sortOrder=="descend"){
    cop=-9999
  }else if (sortOrder=="ascend"){
    cop=999999999999
  }else{
   cop=-999999;
  }

  if (a == null) {
    return cop;
  } else if (a == "None") {
    return cop;
  } else if (a == "na") {
    return cop;
 
  } else {
    return a;
  }
}


function setnull2(a) {
  //console.log('whatttttttttttt',a)
  if (a == null) {
    return -9999;
  } else if (a == "None") {
    return -9999;
  } else if (a == "na") {
    return -9999;
  } else if (a == "") {
    return -9999;

  } else if (a == "0.000") {
    //console.log('CCCCCCCCCCCCCCCCCc',a)
    return -8888;  
  } else {
    return a*1;
  }
}
function dollerchk(a) {
  if (a == "None") {
    return "";
  } else {
    return "";
  }
}


function setGradeNacolor(a) {
 
  
  if (a==null || a=='None' || a=='NA' || a==null || a=='na' || a=="null"   ) {
    return 1;
  
  }else{
    return 0;
  }
}
function checknegative(a) {
 
  
  if (a==null || a=='None' || a=='NA' || a==null || a=='na' || a=="null"   ) {
    return "black";
  } else if (a >= 0 ) {
    return "";
  }else{
    return "red";
  }
}


function checknegativeBracket(a,b=0,c=0) {
  if (a == "None"  || a == "NA" || a === '' || a=="null" || a==null) {
    return 'na';
  }
  if (a >= 0  && b==0 && c==0) {
    return a;

  }else if (a >= 0  && b==1 && c==0){
    return ''+a+'%';
  
  }else if (a >= 0  && b==0 && c==1){
    return a;

  }else if ( a < 0 &&  b==0 && c==1){
    return'('+Math.abs(a)+')'; 
  } else {
    return '('+Math.abs(a)+'%)';
  }
}


function checknegativeBracketForGradeScore(a,b=0,c=0) {

  if (a == "None" || a == "NA" || a=="null" || a==null) {
    return 'na';
  
  
  } else {
    return a;
  }
}

function checknegativeBracket2(a,b=0,c=0) {
  var nf = new Intl.NumberFormat()
  if (a == "None" || a == "" || a == "NA" || a=="null" || a==null) {
    return 'na';
  }
  else if (a==100){
    return '100.0%';
  }
  else if (a<0){
    return '('+nf.format(Math.abs(parseFloat(a).toFixed(1)))+'%)';
  }
  else {
    
    return  roundedToFixed(a,1)+'%';
  }
}

function roundedToFixed(input, digits){
  var rounded = Math.pow(10, digits);
  return (Math.round(input * rounded) / rounded).toFixed(digits);
}
function checknegradeval(a) {
  if (a == "None" || a == "" || a == "NA" || a=="null" || a==null) {
    return 'na';
  }else {
    return a 
  }
}



function setGradeColor(a) {
  if (a == "A") {
    return "#38761d";
  }
  if (a == "B") {
    return "#6aa84f";
  }

  if (a == "C") {
    return "#f1c232";
  }

  if (a == "D") {
    return "#cc0000";
  }

  if (a == "F") {
    return "#990000";
  }

  return "black";
}


const getRandomuserParams = (params) => {
  return {
    screenRating: params.pagination.pageSize,
    page: params.pagination.current,
    ...params,
  };
};

class TableAPPClass extends React.Component {

  constructor(props) {
    super(props);




/////////////////////////////////////////////////////////////////////

const hovertext = <span>Click "+" to add this stock to a saved portfolio.</span>;

this.columns = [
  {
    title:  <Typography.Text underline  >
             Ticker
            </Typography.Text>,
    dataIndex: "ticker",
    align:'left',
    width:'10%',
    sorter: (a, b) => a.ticker.localeCompare(b.ticker),
    sortDirections: ["descend", "ascend"],
    render: (text, record) => (
      
        <div  ><Tooltip placement="topLeft" title={hovertext}><a id={text}     onClick={(e) => { this.handle(text) }} >    <PlusCircleTwoTone id={text} twoToneColor="#c7af00"   /></a></Tooltip>&nbsp;
      <a target="_blank" href={"/stock/ticker/" + text}>{text}</a>  </div> 
     
   ),
  },
  {
    title: <Typography.Text underline  >
    Company
   </Typography.Text>, 
    sorter: (a, b) => a.company.localeCompare(b.company),
    dataIndex: "company",
    align:'left',
    width:'20%',
  },
  {
    
    title: <Typography.Text underline  >
    Sector
      </Typography.Text>, 
    sorter: (a, b) => a.sector.localeCompare(b.sector),
    dataIndex: "sector",
    align:'left',
    width:'15%',

    render: (sector) => (
      <span>
        
          {sector}
         
      </span>
    ),
  },

  {
  
    title: <Typography.Text underline  >
    Industry
   </Typography.Text>, 
     width:'18%',
    sorter: (a, b) => a.industry.localeCompare(b.industry),
    dataIndex: "industry",
    align:'left',
   

    render: (industry) => (
      <span>
         
          {industry}
        
      </span>
    ),
  },


  {
     
    title: <Typography.Text underline  >
    Price
   </Typography.Text>, 
    dataIndex: "price",
    align:'left',
    
    width:'8%',
    sorter: (a, b,sortOrder) => setnull(a.price,sortOrder ) - setnull(b.price,sortOrder ),

    sortDirections: ["descend", "ascend"],

    render(text, record) {
      return {
       

        children: (
          <div>
            
           <Statistic   prefix={text=='None' || text=='na' || text=='' || text==null ?'':'$'}     value= {checknegativeBracket(text)}   precision={2}  valueStyle={{ fontSize:'14px',color: checknegative(text) }}/>
          </div>
        ),
      };
    },
  },


  {
     
    title: <Typography.Text underline  >
    Volume-Avg Daily (K)
   </Typography.Text>, 
    dataIndex: "avd_10d",
    align:'left',
    
    width:'8%',
    sorter: (a, b,sortOrder) => setnull(a.avd_10d,sortOrder ) - setnull(b.avd_10d,sortOrder ),

    sortDirections: ["descend", "ascend"],

    render(text, record) {
      return {
       

        children: (
          <div>
            
           <Statistic   prefix={text=='None' || text=='na' || text=='' || text==null ?'':''}     value= {checknegativeBracket(text)}     valueStyle={{ fontSize:'14px',color: checknegative(text) }}/>
          </div>
        ),
      };
    },
  },


  
  {
    title: <Typography.Text underline  >
   Market Cap (Mil)
   </Typography.Text>, 
  
  width:'8%',
    dataIndex: "mktcap",
    align:'left',
 
    sorter: (a, b,sortOrder) => setnull(a.mktcap,sortOrder) - setnull(b.mktcap,sortOrder),

    sortDirections: ["descend", "ascend"],

    render(text, record) {
      return {
       

        children: (
          <div>
            
            <Statistic  value= {checknegativeBracket(text)}  prefix={text=='None' || text=='na' || text=='' || text==null ?'':'$'}     valueStyle={{ fontSize:'14px', color: checknegative(text)}}/>
          </div>
        ),
      };
    },
  },



  {
    title: <Typography.Text underline  >
    Dividend
   </Typography.Text>, 
 width:'8%',

    dataIndex: "dps_ind",
    align:'left',
    
 
    sorter: (a, b,sortOrder) => setnull(a.dps_ind,sortOrder) - setnull(b.dps_ind,sortOrder),
    sortDirections: ["descend", "ascend"],

    render(text, record) {
      return {
       

        children: (
          <div>
            
            <Statistic  value= {checknegativeBracket(text)}  prefix={text=='None' || text=='na' || text=='' || text==null ?'':'$'}  precision={3}     valueStyle={{ fontSize:'14px', color: checknegative(text)}}/>
        
          </div>
        ),
      };
    },
  },


  {
    title: <Typography.Text underline  >
    Exchange
   </Typography.Text>, 
 width:'8%',

    dataIndex: "exchange",
    align:'left',
    
    sorter: (a, b) => a.exchange.localeCompare(b.exchange),
    sortDirections: ["descend", "ascend"],

    render(text, record) {
      return {
       

        children: (
          <div>
            {dollerchk(text)}
            <Statistic  value= {text}     valueStyle={{ fontSize:'14px', color: text}}/>
          </div>
        ),
      };
    },
  },


  {
    title: <Typography.Text underline  >
    ADR
   </Typography.Text>, 
 width:'8%',

    dataIndex: "adr",
    align:'left',
    sorter: (a, b) => a.adr.toString().localeCompare(b.adr.toString()),
   
    
    sortDirections: ["descend", "ascend"],

    render(text, record) {
      return {
       

        children: (
          <div>
            {dollerchk(text)}
            <Statistic  value= {text}     valueStyle={{ fontSize:'14px', color: text}}/>
          </div>
        ),
      };
    },
  }

];

this.headers = [

  { label: "Ticker ", key: "ticker" },
  { label: "Company ", key: "company" } ,
  { label: "Sector ", key: "sector" } ,
  { label: "Industry ", key: "industry" } ,
  { label: "Price", key: "price" } ,
  { label: "Volume-Avg Daily (K)", key: "avd_10d" } ,
  { label: "Market Cap (Mil) ", key: "mktcap" } ,
  { label: "Dividend ", key: "dps_ind" } ,
  { label: "Exchange ", key: "exchange" } ,
  { label: "ADR ", key: "adr" } ,

];


this.columns2 = [
  {
   
    title: <Typography.Text underline  >
 Ticker
   </Typography.Text>, 
    dataIndex: "ticker",
    align:'left',
    width:'11%',
    sorter: (a, b) => a.ticker.localeCompare(b.ticker),
    sortDirections: ["descend", "ascend"],
    
    render: (text, record) => (
      
      <div  ><Tooltip placement="topLeft" title={hovertext}><a id={text}     onClick={(e) => { this.handle(text) }} >   <PlusCircleTwoTone id={text} twoToneColor="#c7af00"   /></a></Tooltip>&nbsp;
      <a target="_blank" href={"/stock/ticker/" + text}>{text}</a></div> 
   
 ),
  },
  {
    
    title: <Typography.Text underline  >
    Company
      </Typography.Text>, 
    sorter: (a, b) => a.company.localeCompare(b.company),
    dataIndex: "company",
    align:'left',
    width:'24%',

    
  },
//////////////////
  {
    title: 'Value',
    align:'center',
  
    children: [
  {
   
    title: <Typography.Text underline  >
    Grade
      </Typography.Text>, 
    dataIndex: "valueGrade",
    align:'center',
   
    sorter: (a, b,sortOrder) => setnull(a.valueScore,sortOrder) - setnull(b.valueScore,sortOrder),
    sortDirections: ["descend", "ascend"],
    
    render(text, record) {
      return {
        children: (
          setGradeNacolor(text)==1?'na':  <Badge
          className="site-badge-count-109"
             count={checknegradeval(text)}
            style={{ backgroundColor: setGradeColor(text) }}
          />
        ),
      };
    },
  },
  {
    
    title: <Typography.Text underline  >
    Score
      </Typography.Text>, 
    dataIndex: "valueScore",
    align:'center',
    
    render(text, record) {
      return {
       

        children: (
          <div>
            {dollerchk(text)}
            <Statistic  value= {checknegativeBracketForGradeScore(text)}     valueStyle={{ fontSize:'14px', color: checknegative(text)}}/>
          </div>
        ),
      };
    },
    sorter: (a, b,sortOrder) => setnullZero(a.valueScore,sortOrder) - setnullZero(b.valueScore,sortOrder),
  
  },]

},

  ///////

  {
    title: 'Momentum',
    align:'center',
    children: [
  {
   
    title: <Typography.Text underline  >
    Grade
      </Typography.Text>, 
    dataIndex: "momentumGrade",
    align:'center',
   
    sorter: (a, b,sortOrder) => setnull(a.momentumScore,sortOrder) - setnull(b.momentumScore,sortOrder),
    sortDirections: ["descend", "ascend"],

   
    render(text, record) {
      return {
        children: (
          setGradeNacolor(text)==1?'na': <Badge
            className="site-badge-count-109"
             count={checknegradeval(text)}
            style={{ backgroundColor: setGradeColor(text) }}
          />
        ),
      };
    },
  },

  {
     
    title: <Typography.Text underline  >
    Score
      </Typography.Text>, 
    sorter: (a, b) => setnullZero(a.momentumScore) - setnullZero(b.momentumScore),
    sortDirections: ["descend", "ascend"],
    dataIndex: "momentumScore",
    align:'center',
  

    render(text, record) {
      return {
       

        children: (
          <div>
            {dollerchk(text)}
            <Statistic  value= {checknegativeBracketForGradeScore(text)}     valueStyle={{ fontSize:'14px', color: checknegative(text)}}/>
          </div>
        ),
      };
    },
    
  },]


},

{
  title: 'Quality',
  align:'center',
  children: [
  {
    
    title: <Typography.Text underline  >
    Grade
      </Typography.Text>, 
    dataIndex: "qualityGrade",
    align:'center',
   
    sorter: (a, b,sortOrder) => setnull(a.qualityScore2,sortOrder) - setnull(b.qualityScore2,sortOrder),
    sortDirections: ["descend", "ascend"],

   
    render(text, record) {
      return {
        children: (
          setGradeNacolor(text)==1?'na': <Badge
            className="site-badge-count-109"
             count={checknegradeval(text)}
            style={{ backgroundColor: setGradeColor(text) }}
          />
        ),
      };
    },
  },

  {
     
    title: <Typography.Text underline  >
    Score
      </Typography.Text>, 
    sorter: (a, b,sortOrder) => setnullZero(a.qualityScore2,sortOrder) - setnullZero(b.qualityScore2,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "qualityScore2",
    align:'center',
   
    render(text, record) {
      return {
       

        children: (
          <div>
            {dollerchk(text)}
            <Statistic  value= {checknegativeBracketForGradeScore(text)}     valueStyle={{ fontSize:'14px', color: checknegative(text)}}/>
          </div>
        ),
      };
    },
   
  },
]},

{
  title: 'Growth',
  align:'center',
  children: [
  {
     
    title: <Typography.Text underline  >
    Grade
      </Typography.Text>, 
    sorter: (a, b,sortOrder) => setnull(a.growthScore,sortOrder) - setnull(b.growthScore,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "growthGrade",
    align:'center',
  
    render(text, record) {
      return {
        children: (
          setGradeNacolor(text)==1?'na':<Badge
            className="site-badge-count-109"
             count={checknegradeval(text)}
            style={{ backgroundColor: setGradeColor(text) }}
          />
        ),
      };
    },
  },
  {
     
     
    title: <Typography.Text underline  >
    Score
      </Typography.Text>, 
    sorter: (a, b,sortOrder) => setnullZero(a.growthScore,sortOrder) - setnullZero(b.growthScore,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "growthScore",
    align:'center',
 
    render(text, record) {
      return {
       

        children: (
          <div>
            {dollerchk(text)}
            <Statistic  value= {checknegativeBracketForGradeScore(text)}     valueStyle={{ fontSize:'14px', color: checknegative(text)}}/>
          </div>
        ),
      };
    },

   
  },]
},


{
  title: 'EPS Revisions',
  align:'center',
  children: [
  {
  
    title: <Typography.Text underline  >
    Grade
      </Typography.Text>, 
    sorter: (a, b,sortOrder) => setnull(a.revisionsScore,sortOrder) - setnull(b.revisionsScore,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "revisionGrade",
    align:'center',
  
  
    render(text, record) {
      return {
        children: (
          setGradeNacolor(text)==1?'na': <Badge
            className="site-badge-count-109"
             count={checknegradeval(text)}
            style={{ backgroundColor: setGradeColor(text) }}
          />
        ),
      };
    },
  },

  {
   
    title: <Typography.Text underline  >
    Score
      </Typography.Text>, 

    sorter: (a, b,sortOrder) => setnullZero(a.revisionsScore,sortOrder) - setnullZero(b.revisionsScore,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "revisionsScore",
    align:'center',
   
    render(text, record) {
      return {
       

        children: (
          <div>
            {dollerchk(text)}
            <Statistic  value= {checknegativeBracketForGradeScore(text)}     valueStyle={{ fontSize:'14px', color: checknegative(text)}}/>
          </div>
        ),
      };
    },
   
  },]
},


];





this.headers2 = [
  { label: "Ticker ", key: "ticker" },
  { label: "Company ", key: "company" } ,
  { label: "Value Grade ", key: "valueGrade" } ,
  { label: "Value Score ", key: "valueScore" } ,
  { label: "Momentum Grade", key: "momentumGrade" } ,
  { label: "Momentum Score", key: "momentumScore" } ,
  { label: "Quality Grade", key: "qualityGrade" } ,
  { label: "Quality Score", key: "qualityScore2" } ,
  { label: "Growth Grade", key: "growthGrade" } ,
  { label: "Growth Score", key: "growthScore" } ,

  { label: "Revision Grade", key: "revisionGrade" } ,
  { label: "Revisions Score", key: "revisionsScore" } ,

];




this.columns3 = [
  {
    
    title: <Typography.Text underline  >
    Ticker
      </Typography.Text>, 
    dataIndex: "ticker",
    width:'6%',
    sorter: (a, b) => a.ticker.localeCompare(b.ticker),
    sortDirections: ["descend", "ascend"],
    fixed: "left",
    render: (text, record) => (
      
      <div  ><Tooltip placement="topLeft" title={hovertext}><a id={text}     onClick={(e) => { this.handle(text) }} >   <PlusCircleTwoTone id={text} twoToneColor="#c7af00"   /></a></Tooltip>&nbsp;
      <a target="_blank" href={"/stock/ticker/" + text}>{text}</a></div> 
   
 ),
  },
  {
  
    title: <Typography.Text underline  >
    Company
      </Typography.Text>, 
        width:'11%',
    sorter: (a, b) => a.company.localeCompare(b.company),
    dataIndex: "company",
  },

  {
   
    title: <Typography.Text underline  >
   Sales Growth 12m
      </Typography.Text>, 
    dataIndex: "sales_g1t",
  
    sorter: (a, b,sortOrder) => setnull(a.sales_g1t,sortOrder) - setnull(b.sales_g1t,sortOrder),
    // sorter: (a, b) => setnull(a.sales_g1t).localeCompare(setnull(b.sales_g1t)),
    sortDirections: ["descend", "ascend"],

    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}       valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },
  {
 
    title: <Typography.Text underline  >
       Sales Growth 1yr
      </Typography.Text>, 

    dataIndex: "sales_g1f",
 
    // sorter: (a, b) => setnull(a.sales_g1f) - setnull(b.sales_g1f),
    sorter: (a, b,sortOrder) => setnull(a.sales_g1f,sortOrder) - setnull(b.sales_g1f,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },
  {
 
    title: <Typography.Text underline  >
          Sales Growth 3yr
        </Typography.Text>, 
  
    dataIndex: "sales_g3f",
    sorter: (a, b,sortOrder) => setnull(a.sales_g3f,sortOrder) - setnull(b.sales_g3f,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },
  {
    
    title: <Typography.Text underline  >
      Sales Growth 5yr
          </Typography.Text>, 
    dataIndex: "sales_g5f",
   
    //sorter: (a, b) => a.sales_g5f.localeCompare(b.sales_g5f),

    sorter: (a, b,sortOrder) => setnull(a.sales_g5f,sortOrder) - setnull(b.sales_g5f,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
  
    title: <Typography.Text underline  >
   Sales Growth 7yr
           </Typography.Text>, 
 
    dataIndex: "sales_g7f",

    sorter: (a, b,sortOrder) => setnull(a.sales_g7f,sortOrder) - setnull(b.sales_g7f,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}       valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
    
    title: <Typography.Text underline  >
   EPS Dil Cont Growth 12m
            </Typography.Text>, 
  
    dataIndex: "epsdc_g1t",

    sorter: (a, b,sortOrder) => setnull(a.epsdc_g1t,sortOrder) - setnull(b.epsdc_g1t,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
   
    title: <Typography.Text underline  >
   EPS Dil Cont Growth 1yr
             </Typography.Text>, 
    dataIndex: "epsdc_g1f",
   
    sorter: (a, b,sortOrder) => setnull(a.epsdc_g1f,sortOrder) - setnull(b.epsdc_g1f,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
   
    title: <Typography.Text underline  >
EPS Dil Cont Growth 3yr
              </Typography.Text>, 
    dataIndex: "epsdc_g3f",
   
    sorter: (a, b,sortOrder) => setnull(a.epsdc_g3f,sortOrder) - setnull(b.epsdc_g3f,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
   
    title: <Typography.Text underline  >
   EPS Dil Cont Growth 5yr
               </Typography.Text>, 
    dataIndex: "epsdc_g5f",
   
    sorter: (a, b,sortOrder) => setnull(a.epsdc_g5f,sortOrder) - setnull(b.epsdc_g5f,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },
  {
    
    title: <Typography.Text underline  >
  EPS Dil Cont Growth 7yr
                </Typography.Text>, 
    dataIndex: "epsdc_g7f",
   
    sorter: (a, b,sortOrder) => setnull(a.epsdc_g7f,sortOrder) - setnull(b.epsdc_g7f,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
    
      
    title: <Typography.Text underline  >
   Dividends Per Share Growth 12m
                </Typography.Text>, 
 
    dataIndex: "dps_g1t",

    sorter: (a, b,sortOrder) => setnull(a.dps_g1t,sortOrder) - setnull(b.dps_g1t,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
   
    title: <Typography.Text underline  >
  Dividends Per Share Growth 1yr
                 </Typography.Text>, 
    dataIndex: "dps_g1f",
  
    sorter: (a, b,sortOrder) => setnull(a.dps_g1f,sortOrder) - setnull(b.dps_g1f,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
    
   
    title: <Typography.Text underline  >
    Dividends Per Share Growth 3yr
                   </Typography.Text>, 

 
    dataIndex: "dps_g3f",

    sorter: (a, b,sortOrder) => setnull(a.dps_g3f,sortOrder) - setnull(b.dps_g3f,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
   
    title: <Typography.Text underline  >
     Dividends Per Share Growth 5yr
                   </Typography.Text>, 
    dataIndex: "dps_g5f",
   
    sorter: (a, b,sortOrder) => setnull(a.dps_g5f,sortOrder) - setnull(b.dps_g5f,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
     
    title: <Typography.Text underline  >
     Dividends Per Share Growth 7yr
                  </Typography.Text>, 
    dataIndex: "dps_g7f",
 
    sorter: (a, b,sortOrder) => setnull(a.dps_g7f,sortOrder) - setnull(b.dps_g7f,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
  
    title: <Typography.Text underline  >
 Operating Cash Growth Qtrly YoY
                 </Typography.Text>, 
    dataIndex: "CashFromOperationsYOY",
  
    sorter: (a, b,sortOrder) =>
      setnull(a.CashFromOperationsYOY,sortOrder) - setnull(b.CashFromOperationsYOY,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },
  {
    
    title: <Typography.Text underline  >
    Operating Cash Growth 12m
                 </Typography.Text>, 
    sorter: (a, b,sortOrder) =>
      setnull(a.CashFromOperations12m,sortOrder) - setnull(b.CashFromOperations12m,sortOrder),
    sortDirections: ["descend", "ascend"],
 
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },

    dataIndex: "CashFromOperations12m",
  },
  {
  
    title: <Typography.Text underline  >
 Operating Cash Growth 1yr
                 </Typography.Text>, 
 
    sorter: (a, b,sortOrder) =>
      setnull(a.CashFromOperations1Yr,sortOrder) - setnull(b.CashFromOperations1Yr,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },

    dataIndex: "CashFromOperations1Yr",
  },
  {
     
    title: <Typography.Text underline  >
Operating Cash Growth 3yr
                   </Typography.Text>, 
 
    sorter: (a, b,sortOrder) =>
      setnull(a.CashFromOperations3Yr,sortOrder) - setnull(b.CashFromOperations3Yr,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },

    dataIndex: "CashFromOperations3Yr",
  },

  {
     
    title: <Typography.Text underline  >
  Operating Cash Growth 5yr
                   </Typography.Text>, 
 
    sorter: (a, b,sortOrder) =>
      setnull(a.CashFromOperations5Yr,sortOrder) - setnull(b.CashFromOperations5Yr,sortOrder),

    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },

    dataIndex: "CashFromOperations5Yr",
  },

  {
     

    title: <Typography.Text underline  >
    Operating Cash Growth 7yr
                    </Typography.Text>, 

 
    sorter: (a, b,sortOrder) =>
      setnull(a.CashFromOperations7Yr,sortOrder) - setnull(b.CashFromOperations7Yr,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },

    dataIndex: "CashFromOperations7Yr",
  },

  {
    
    title: <Typography.Text underline  >
   Free Cash Growth Qtrly YoY
                    </Typography.Text>, 
   
    sorter: (a, b,sortOrder) => setnull(a.fcfpsYOY,sortOrder) - setnull(b.fcfpsYOY,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
    dataIndex: "fcfpsYOY",
  },
  {
     
    title: <Typography.Text underline  >
   Free Cash Growth 12m
                     </Typography.Text>,
 

    sorter: (a, b,sortOrder) => setnull(a.fcfps_g1t,sortOrder) - setnull(b.fcfps_g1t,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
    dataIndex: "fcfps_g1t",
  },
  {
     
    title: <Typography.Text underline  >
     Free Cash Growth 1yr
                     </Typography.Text>,
 
    sorter: (a, b,sortOrder) => setnull(a.fcfps_g1f,sortOrder) - setnull(b.fcfps_g1f,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
    dataIndex: "fcfps_g1f",
  },
  {
 
    title: <Typography.Text underline  >
      Free Cash Growth 3yr
                     </Typography.Text>,


    sorter: (a, b,sortOrder) => setnull(a.fcfps_g3f,sortOrder) - setnull(b.fcfps_g3f,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
    dataIndex: "fcfps_g3f",
  },

  {
 
    title: <Typography.Text underline  >
    Free Cash Growth 5yr
                   </Typography.Text>,


    sorter: (a, b,sortOrder) => setnull(a.fcfps_g5f,sortOrder) - setnull(b.fcfps_g5f,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}     valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
    dataIndex: "fcfps_g5f",
  },

  {
     
    title: <Typography.Text underline  >
     Free Cash Growth 7yr
                   </Typography.Text>,

 
    sorter: (a, b,sortOrder) => setnull(a.fcfps_g7f,sortOrder) - setnull(b.fcfps_g7f,sortOrder),
    sortDirections: ["descend", "ascend"],
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
    dataIndex: "fcfps_g7f",
  },
];









this.headers3 = [
  { label: "Ticker ", key: "ticker" },
  { label: "Company ", key: "company" } ,
  { label: "Sales Growth 12m", key: "sales_g1t" } ,
  { label: "Sales Growth 1yr", key: "sales_g1f" } ,
  { label: "Sales Growth 3yr", key: "sales_g3f" } ,
  { label: "Sales Growth 5yr", key: "sales_g5f" } ,
  { label: "Sales Growth 7yr", key: "sales_g7f" } ,
  { label: "EPS Dil Cont Growth 12m", key: "epsdc_g1t" } ,
  { label: "EPS Dil Cont Growth 1yr", key: "epsdc_g1f" } ,
  { label: "EPS Dil Cont Growth 3yr", key: "epsdc_g3f" } ,

  { label: "EPS Dil Cont Growth 5yr", key: "epsdc_g5f" } ,
  { label: "EPS Dil Cont Growth 7yr", key: "epsdc_g7f" } ,

  { label: "Dividends Per Share Growth 12m", key: "dps_g1t" } ,
  { label: "Dividends Per Share Growth 1yr", key: "dps_g1f" } ,
  { label: "Dividends Per Share Growth 3yr", key: "dps_g3f" } ,
  { label: "Dividends Per Share Growth 5yr", key: "dps_g5f" } ,

  { label: "Dividends Per Share Growth 7yr", key: "dps_g7f" } ,
  { label: "Operating Cash Growth Qtrly YoY", key: "CashFromOperationsYOY" } ,
  { label: "Operating Cash Growth 12m", key: "CashFromOperations12m" } ,

  { label: "Operating Cash Growth 1yr", key: "CashFromOperations1Yr" } ,
  { label: "Operating Cash Growth 3yr", key: "CashFromOperations3Yr" } ,
  { label: "Operating Cash Growth 5yr", key: "CashFromOperations5Yr" } ,

  { label: "Operating Cash Growth 7yr", key: "CashFromOperations7Yr" } ,
  { label: "Free Cash Growth Qtrly YoY", key: "fcfpsYOY" } ,
  { label: "Free Cash Growth 12m", key: "fcfps_g1t" } ,

  { label: "Free Cash Growth 1yr", key: "fcfps_g1f" } ,
  { label: "Free Cash Growth 3yr", key: "fcfps_g3f" } ,
  { label: "Free Cash Growth 5yr", key: "fcfps_g5f" } ,
  { label: "Free Cash Growth 7yr", key: "fcfps_g7f" } ,

];










this.columns4 = [
  {
    
    title: <Typography.Text underline  >
    Ticker
                  </Typography.Text>,
    dataIndex: "ticker",
    width:'14%',
    sorter: (a, b) => a.ticker.localeCompare(b.ticker),
    sortDirections: ["descend", "ascend"],
   
    render: (text, record) => (
      
      <div  ><Tooltip placement="topLeft" title={hovertext}><a id={text}     onClick={(e) => { this.handle(text) }} >   <PlusCircleTwoTone id={text} twoToneColor="#c7af00"   /></a></Tooltip>&nbsp;
      <a target="_blank" href={"/stock/ticker/" + text}>{text}</a></div> 
   
 ),
  },
  {
 
    title: <Typography.Text underline  >
    Company
                  </Typography.Text>,
    sorter: (a, b) => a.company.localeCompare(b.company),
    dataIndex: "company",
    width:'25%',
   
  },
  {
    
    title: <Typography.Text underline  >
  Return on Assets (ROA)
                  </Typography.Text>,
                      
    sorter: (a, b,sortOrder) => setnull(a.roa_12m,sortOrder) - setnull(b.roa_12m,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "roa_12m",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
   
    title: <Typography.Text underline  >
    Return on Equity (ROE)
                  </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.roe_12m,sortOrder) - setnull(b.roe_12m,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "roe_12m",
   
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
     
    title: <Typography.Text underline  >
     Gross Margin 12m
                  </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.gpm_12m,sortOrder) - setnull(b.gpm_12m,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "gpm_12m",
 
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
     
    title: <Typography.Text underline  >
     Operating Margin 12m
                 </Typography.Text>,

    sorter: (a, b,sortOrder) => setnull(a.opm_12m,sortOrder) - setnull(b.opm_12m,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "opm_12m",
   
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
    
    title: <Typography.Text underline  >
    Net Margin 12m
               </Typography.Text>,

    sorter: (a, b,sortOrder) => setnull(a.npm_12m,sortOrder) - setnull(b.npm_12m,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "npm_12m",
   
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },
];




this.headers4 = [
  { label: "Ticker ", key: "ticker" },
  { label: "Company ", key: "company" } ,
  { label: "Return on Assets (ROA)", key: "roa_12m" } ,
  { label: "Return on Equity (ROE)", key: "roe_12m" } ,
  { label: "Gross Margin 12m", key: "gpm_12m" } ,
  { label: "Operating Margin 12m", key: "opm_12m" } ,
  { label: "Net Margin 12m", key: "npm_12m" } ,
   

];




this.columns5 = [
  {
    
    title: <Typography.Text underline  >
    Ticker
               </Typography.Text>,
    dataIndex: "ticker",
   width:'12%',
    sorter: (a, b) => a.ticker.localeCompare(b.ticker),
    sortDirections: ["descend", "ascend"],
    
    render: (text, record) => (
      
      <div  ><Tooltip placement="topLeft" title={hovertext}><a id={text}     onClick={(e) => { this.handle(text) }} >   <PlusCircleTwoTone id={text} twoToneColor="#c7af00"   /></a></Tooltip>&nbsp;
      <a target="_blank" href={"/stock/ticker/" + text}>{text}</a></div> 
   
 ),
  },
  {
     
    title: <Typography.Text underline  >
    Company
               </Typography.Text>,
               width:'25%',
    sorter: (a, b) => a.company.localeCompare(b.company),
    dataIndex: "company",
    
    
  },
  {
    
    title: <Typography.Text underline  >
    F-Score
               </Typography.Text>,
                width:'8%',
    sorter: (a, b,sortOrder) => setnull(a.fscore_12m,sortOrder) - setnull(b.fscore_12m,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "fscore_12m",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text)}     valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
       
    title: <Typography.Text underline  >
    Current Ratio
               </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.curr_q1,sortOrder) - setnull(b.curr_q1,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "curr_q1",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}       valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
    
    title: <Typography.Text underline  >
    Payout Ratio
               </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.payout_12m,sortOrder) - setnull(b.payout_12m,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "payout_12m",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
     
    title: <Typography.Text underline  >
    Long-Term Debt to Equity
               </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.ltd_eq_q1,sortOrder) - setnull(b.ltd_eq_q1,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "ltd_eq_q1",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}       valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
  
    title: <Typography.Text underline  >
    Times Interest Earned
               </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.tie_12m,sortOrder) - setnull(b.tie_12m,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "tie_12m",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,0,1)}     valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
    
    title: <Typography.Text underline  >
    Altman's Z Double Prime 
               </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.altmanZ,sortOrder) - setnull(b.altmanZ,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "altmanZ",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,0,1)}   valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },
  {
     
    title: <Typography.Text underline  >
    Altman's Z Double Prime Rank
               </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.altmanZRank,sortOrder) - setnull(b.altmanZRank,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "altmanZRank",
    render(text, record) {
      return {
       

        children: <div> {checknegativeBracket(text,0,1)}</div>,
      };
    },
  },
];





this.headers5 = [
  { label: "Ticker ", key: "ticker" },
  { label: "Company ", key: "company" } ,
  { label: "F-Score", key: "fscore_12m" } ,
  { label: "Current Ratio", key: "curr_q1" } ,
  { label: "Payout Ratio", key: "payout_12m" } ,
  { label: "Long-Term Debt to Equity", key: "ltd_eq_q1" } ,
  { label: "Times Interest Earned", key: "tie_12m" } ,

  { label: "Altman's Z Double Prime", key: "altmanZ" } ,
  { label: "Altman's Z Double Prime Rank", key: "altmanZRank" } ,
   

];




this.columns6 = [
  {
    
    title: <Typography.Text underline  >
    Ticker
               </Typography.Text>,
    dataIndex: "ticker",
    sorter: (a, b) => a.ticker.localeCompare(b.ticker),
    sortDirections: ["descend", "ascend"],
    width:'12%',
    render: (text, record) => (
      
      <div  ><Tooltip placement="topLeft" title={hovertext}><a id={text}     onClick={(e) => { this.handle(text) }} >   <PlusCircleTwoTone id={text} twoToneColor="#c7af00"   /></a></Tooltip>&nbsp;
      <a target="_blank" href={"/stock/ticker/" + text}>{text}</a></div> 
   
 ),
  },
  {
    
    title: <Typography.Text underline  >
    Company
               </Typography.Text>,
    sorter: (a, b) => a.company.localeCompare(b.company),
    dataIndex: "company",
    width:'27%',
    
  },




  
  {
   
    title: <Typography.Text underline  >
   Price as % of 52-Week High
               </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.PR_PRH_52W,sortOrder) - setnull(b.PR_PRH_52W,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "PR_PRH_52W",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value=  {checknegativeBracket2(text)}          valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },



  {
     
    title: <Typography.Text underline  >
   4-Week Relative Strength
               </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.rs_04w,sortOrder) - setnull(b.rs_04w,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "rs_04w",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value=  {checknegativeBracket2(text)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
    
    title: <Typography.Text underline  >
    13-Week Relative Strength
               </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.rs_13w,sortOrder) - setnull(b.rs_13w,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "rs_13w",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket2(text)}         valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
    
    title: <Typography.Text underline  >
    26-Week Relative Strength
               </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.rs_26w,sortOrder) - setnull(b.rs_26w,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "rs_26w",
    render(text, record) {
      return {
       

        children: <div>  <Statistic value=  {checknegativeBracket2(text)}        valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
    
    title: <Typography.Text underline  >
    52-Week Relative Strength
               </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.rs_52w,sortOrder) - setnull(b.rs_52w,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "rs_52w",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value=  {checknegativeBracket2(text)}       valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },




  {
   
    title: <Typography.Text underline  >
    Weighted 4Qs Relative Strength
               </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.rsw_4q,sortOrder) - setnull(b.rsw_4q,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "rsw_4q",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value=  {checknegativeBracket2(text)}          valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

 

];




this.headers6 = [
  { label: "Ticker ", key: "ticker" },
  { label: "Company ", key: "company" } ,
  { label: "Price as % of 52-Week High", key: "PR_PRH_52W" } ,
  { label: "4-Week Relative Strength", key: "rs_04w" } ,
  { label: "13-Week Relative Strength", key: "rs_13w" } ,
  { label: "26-Week Relative Strength", key: "rs_26w" } ,
  { label: "52-Week Relative Strength", key: "rs_52w" } ,
  { label: "Weighted 4Qs Relative Strength", key: "rsw_4q" } ,
 
   

];







this.columns7 = [
  {
   
    title: <Typography.Text underline  >
    Ticker
               </Typography.Text>,
    dataIndex: "ticker",
    sorter: (a, b) => a.ticker.localeCompare(b.ticker),
    sortDirections: ["descend", "ascend"],
    fixed: "left",
    width:'10%',
    render: (text, record) => (
      
      <div  ><Tooltip placement="topLeft" title={hovertext}><a id={text}     onClick={(e) => { this.handle(text) }} >   <PlusCircleTwoTone id={text} twoToneColor="#c7af00"   /></a></Tooltip>&nbsp;
      <a target="_blank" href={"/stock/ticker/" + text}>{text}</a></div> 
   
 ),
  },
  {
    
    title: <Typography.Text underline  >
    Company
               </Typography.Text>,
               width:'21%',
    sorter: (a, b) => a.company.localeCompare(b.company),
    dataIndex: "company",
  },
  {
    
    title: <Typography.Text underline  >
  Price/Earnings
               </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.PE,sortOrder) - setnull(b.PE,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "PE",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text)}     valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
     
    title: <Typography.Text underline  >
   Fwd Price/Earnings
               </Typography.Text>,
                width:'6%',
    sorter: (a, b,sortOrder) => setnull(a.PE_EY0,sortOrder) - setnull(b.PE_EY0,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "PE_EY0",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,0,1)}    valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
  
    title: <Typography.Text underline  >
    PEG Fwd <br></br> PE to Hist <br></br> Growth
              </Typography.Text>,
    sorter: (a, b,sortOrder) =>
      setnull(a.forwardPeToHistorical,sortOrder) - setnull(b.forwardPeToHistorical,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "forwardPeToHistorical",
    width:'8%',
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,0,1)}    valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
   
    title: <Typography.Text underline  >
  PEG Div Adj<br></br> Fwd PE Hist<br></br>  Grth
              </Typography.Text>,
               width:'8%',
    sorter: (a, b,sortOrder) =>
      setnull(a.dividendAdjPEGRatio,sortOrder) - setnull(b.dividendAdjPEGRatio,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "dividendAdjPEGRatio",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,0,1)}    valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
   
    title: <Typography.Text underline  >
    Price/Book Value
               </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.PBVPS,sortOrder) - setnull(b.PBVPS,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "PBVPS",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,0,1)}  valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
     
    title: <Typography.Text underline  >
    Price/Sales
               </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.Psps,sortOrder) - setnull(b.Psps,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "Psps",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,0,1)}    valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
    
    title: <Typography.Text underline  >
 Price/Cash Flow
               </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.PCFPS,sortOrder) - setnull(b.PCFPS,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "PCFPS",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,0,1)}   valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
     
    title: <Typography.Text underline  >
    Price/Free Cash Flow
               </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.pfcps,sortOrder) - setnull(b.pfcps,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "pfcps",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,0,1)}   valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
    
    title: <Typography.Text underline  >
    EV/EBITDA
               </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.eveda_12m,sortOrder) - setnull(b.eveda_12m,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "eveda_12m",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,0,1)}    valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
     
    title: <Typography.Text underline  >
    Buyback Yield
               </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.bby,sortOrder) - setnull(b.bby,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "bby",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}       valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
   
    title: <Typography.Text underline  >
    Shareholder Yield
               </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.shy,sortOrder) - setnull(b.shy,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "shy",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}       valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },
  {
    
    title: <Typography.Text underline  >
      Yield
               </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.yield,sortOrder) - setnull(b.yield,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "yield",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },
];




this.headers7 = [
  { label: "Ticker ", key: "ticker" },
  { label: "Company ", key: "company" } ,
  { label: "Price/Earnings", key: "PE" } ,
  { label: "Fwd Price/Earnings", key: "PE_EY0" } ,
  { label: "PEG Fwd  PE to Hist  Growth", key: "forwardPeToHistorical" } ,
  { label: "  PEG Div Adj  Fwd PE Hist  Grth", key: "dividendAdjPEGRatio" } ,
  { label: " Price/Book Value", key: "PBVPS" } ,
  { label: "Price/Sales", key: "Psps" } ,
  { label: "Price/Cash Flow", key: "PCFPS" } ,
  { label: "Price/Free Cash Flow", key: "pfcps" } ,
  { label: "EV/EBITDA", key: "eveda_12m" } ,
  { label: " Buyback Yield", key: "bby" } ,

  { label: "Shareholder Yield", key: "shy" } ,
  { label: "Yield", key: "yield" } ,
 
 
   

];



this.columns8 = [
  {
    
    title: <Typography.Text underline  >
      Ticker
               </Typography.Text>,
    dataIndex: "ticker",
    sorter: (a, b) => a.ticker.localeCompare(b.ticker),
    sortDirections: ["descend", "ascend"],
    width:'12%',
    render: (text, record) => (
      
      <div  ><Tooltip placement="topLeft" title={hovertext}><a id={text}     onClick={(e) => { this.handle(text) }} >   <PlusCircleTwoTone id={text} twoToneColor="#c7af00"   /></a></Tooltip>&nbsp;
      <a target="_blank" href={"/stock/ticker/" + text}>{text}</a></div> 
   
 ),
  },
  {
    
    title: <Typography.Text underline  >
    Company
             </Typography.Text>,
             width:'28%',
    sorter: (a, b) => a.company.localeCompare(b.company),
    dataIndex: "company",

    
  },
  {
    
    title: <Typography.Text underline  >
   Quarterly Surprise Latest Qtr
             </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.qs_perc,sortOrder) - setnull(b.qs_perc,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "qs_perc",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}    valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
    
    title: <Typography.Text underline  >
   Quarterly Surprise SUE Latest Qtr
             </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.qs_sue_q1,sortOrder) - setnull(b.qs_sue_q1,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "qs_sue_q1",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,0,1)}     valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
   
    title: <Typography.Text underline  >
   EPS Est Q0 % Rev Last Month 
             </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.epsdmp_eq0,sortOrder) - setnull(b.epsdmp_eq0,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "epsdmp_eq0",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },

  {
    
    title: <Typography.Text underline  >
   EPS Est Y0 % Rev Last Month
             </Typography.Text>,
    sorter: (a, b,sortOrder) => setnull(a.epsdmp_ey0,sortOrder) - setnull(b.epsdmp_ey0,sortOrder),
    sortDirections: ["descend", "ascend"],
    dataIndex: "epsdmp_ey0",
    render(text, record) {
      return {
       

        children: <div>  <Statistic  value= {checknegativeBracket(text,1)}      valueStyle={{ fontSize:'14px', color: checknegative(text)}}/></div>,
      };
    },
  },
];
this.headers8 = [
  { label: "Ticker ", key: "ticker" },
  { label: "Company ", key: "company" } ,
  { label: "Quarterly Surprise Latest Qtr", key: "qs_perc" } ,
  { label: "Quarterly Surprise SUE Latest Qtr", key: "qs_sue_q1" } ,
  { label: "EPS Est Q0 % Rev Last Month ", key: "epsdmp_eq0" } ,
  { label: "EPS Est Y0 % Rev Last Month", key: "epsdmp_ey0" } ,
 
 
 
   

];

////////////////////////////////////////////////////////////////////////////


  this.state = {
    showchart: false,
    loadmod: false,
    
    pagination: {
      current: 1,
      pageSize: 10,
    },
    loading: false,
  };
  this.showcharts = this.showcharts.bind(this);
  this.showcharts2 = this.showcharts2.bind(this);
  this.handleCreatePort = this.handleCreatePort.bind(this);
  }
  componentDidMount() {
    const { pagination } = this.state;
    this.fetch({ pagination });

    ///this.fetchhead();
    //this.fetch({ pagination });
  }

  onClick = (e) => {
    console.log('Content: ', e.currentTarget.dataset.id);
  }
  

  fetchhead = (params = {}) => {
    this.setState({ loading: true });
    console.log("head start", 1);
    reqwest({
      url: this.props.apppath + "/include/api/screener/stockScreenerJson.json",
      method: "get",
    }).then((data) => {
      this.props.activateTablehead(data);
      console.log("head", data);

      this.setState({
        loading: false,
        datahead: this.props.tablehead,
      });
    });
    console.log("head done", 1);
  };

  fetch = (params = {}) => {
    this.setState({ loading: true });
    reqwest({
      url:"https://siproupdateonly.s3-accelerate.amazonaws.com/stockScreenerInit.json",
      method: "get",
      type: "json",
      data: getRandomuserParams(params),
    }).then((data) => {
      this.props.activateStocks(data.screenRating);
      this.props.activateRecordtb(data.screenRating.length);
      this.props.activateRecord(data.screenRating.length);
      this.props.activateScreen(false);
      this.setState({
        loading: false,
        recordcounts:data.screenRating.length,
        pagination: {
          ...params.pagination,
          total: 200,
        },
      });
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.fetch({
      sortField: sorter.field,
      sortOrder: sorter.order,
      pagination,
      ...filters,
    });
  };
  


  handle (id) {
    //console.log(id.target)
      this.setState({
        loadmod: true,
        loading: true,
      });
      reqwest({
        url: this.props.apppath + "/include/api/myportfolio/addticker.cfm?ticker="+id+"&uid="+this.props.auid,
        method: "get",
        type: "json",
      }).then((data) => {
   
  if (data.response!=''){
  
        this.setState({
          data2: data,
          loading: false,
          ticker:id,
          pcount:data.length,
        });
      }else{
        this.setState({
          loadmod: false,
          loading: false,
        });
          confirm({
            title: 'Create a portfolio?',
            icon: <ExclamationCircleOutlined />,
            content: 'Sorry, but you do not have any saved portfolio. Please go to My Portfolio to first create and save a portfolio.',
            okText: 'Go to My Portfolio',
            onOk() {
             // this.hidemyportpopUp();
              window.open( "/myportfolio/myportview?vid=1", "_blank");
            },
            onCancel() {
              console.log('Cancel');
            },
          });
      

      }



      });
    }

    hidemyportpopUp(){
    this.setState({
      loadmod: false,
      loading: false,
    });
  }

    showcharts(){
      
      this.setState({
        showchart:true,
      });

    }
    showcharts2(){
      
      this.setState({
        showchart:false,
      });

    }


    handleCreatePort(){
      console.log( this.state.portname );

      if (this.state.portname!=""){
        this.create()
        
      }else{
        alert("Portfolio name is required.")
      }
    }

    create() {
      if (this.state.pcount >= 25) {
        alert(
          "You have reached your limit of Portfolio. To add another Portfolio, you must first delete one of your current Portfolio."
        );
      } else {
        this.setState({
          loadmod: true,
          loading: true,
        });
        const node = this.state.portname;
        //console.log(node)
        axios
          .get(
            this.props.apppath + "/include/api/myportfolio/myportfolio.cfm?name=" +
              node +
              "&tickerList=" +
              this.state.ticker +
              "&uId=" +
              this.props.auid +
              "&action=createPortfolio"
          )
          .then((response) => {
           // this.GetlistTickerMount(this.state.ticker);
           console.log("RES",response.data)
          
            this.addToPort(this.state.ticker,response.data.result.ID,this.state.portname)
            
            this.setState({
              portname: "",
             
            });
           
           // this.added(response.data.RESULT.ID);
            //console.log(response.data )
          })
          .catch((error) => {
            console.log(error)
          });
      }
    }
  
    addToPort (id,pid,name) {
     // console.log(id.target)
        this.setState({
          loadmod: true,
          loading: true,
        });
        reqwest({
          url: this.props.apppath + "/include/api/myportfolio/portfolio.cfm?action=AddTickerFromEval&ticker="+id+"&uid="+this.props.auid+'&pid='+pid,
          method: "get",
          type: "json",
        }).then((data) => {
     
   // console.log(data)
          this.setState({
          
            loading: false,
            ticker:id,
          });
          this.handle(id);
          this.info(id,name); 
        });
       
      }

      info = (id,name) => {
        message.info(id+' added to '+name+ ' portfolio');
      };

      handleChange(e) {
        this.setState({ portname: e.target.value });
      }

  render() {
 

/* var cat=[];
var catname=[];

if (this.props.datadic.FilterDic != undefined) {
 

  this.props.datadic.FilterDic.categories.map((experience, i) => {

  catname[i]=experience.label;
  cat[i]=experience.id;
  
  })

 // columns1
  
}  
  */


    const handleOk = () => {
      this.setState({
      
        loadmod : false,
      });
    };

    const handleCancel = () => {
      this.setState({
     
        loadmod: false,
      });
    };
    
    const { loading } = this.state;
    

    const tabletop = {
      marginTop: "18px",
    };
  
    const mymsg= [
      "Loading...",
      
    ];
    const item = mymsg[Math.floor(Math.random()*mymsg.length)];
  /*   const operations = <Button onClick={this.showcharts}>Charts</Button>;
    const operations2 = <Button onClick={this.showcharts2}>Data Table</Button>; */
  
    return (
      <div>

 


<Modal
          title="Add   to a Portfolio"
          visible={this.state.loadmod}
      
          onCancel={handleCancel}
          footer={[
            <List.Item><Input  value= {this.state.portname} onChange={ this.handleChange.bind(this) }   placeholder="" /><Button onClick={this.handleCreatePort}>  Create Portfolio  </Button></List.Item>,
            <Button key="back" type="primary" onClick={handleCancel}>
              Close
            </Button>,
          ]}
        >  <Card bordered={true} className="cardstyle">
          {this.state.data2 != "" ? (
            <List
              itemLayout="horizontal"
              dataSource={this.state.data2}
              loading={this.state.loading}
              renderItem={(item) => (
                <List.Item>
                 <List.Item.Meta title={item.name_.toUpperCase()} description="" avatar={item.added==1?<Badge status="success" />:<Badge status="default" />} />
                  {item.added==1?
                  <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: '32px' }} />
                  :<div><Button  icon={<PlusOutlined />} type="primary" loading={false} onClick={() =>this.addToPort(this.state.ticker,item.pId,item.name_)}></Button> 
                  </div>
                 }
                  
                </List.Item>

              )
            
            }
              
            />
          ) : (
            "looks like you don't have save filters, Add filter to save"
          )}

          </Card>
        </Modal>

      
       
     
{/* tabBarExtraContent={operations} */}
{this.state.showchart==false?

<div>

        <Tabs defaultActiveKey="1" style={{ marginBottom: 32 }}     
        
        tabBarExtraContent={   <Tag color="#108ee9"> Viewing {this.props.recordtb} companies </Tag> } 
         >

       
<TabPane tab={<span style={{fontWeight:'700'}}>Stock Basics</span>}  key="1">

            <Table
            style={{width:'80%'}}
              columns={this.columns}
              className="tb1"
              dataSource={
                this.props.stocks
              }
              scroll={{ x:1000  }}
              pagination={true}
              loading={{spinning:loading,tip:item}}
              //pagination={({ defaultPageSize: 140 }, { position: ["bottomRight"] })}
              pagination={{ defaultPageSize: 40 }}
              // onChange={this.handleTableChange}
              bordered
              title={() => <Tag color="rgb(40 95 17)">  {this.props.stocks != 0? <CSVLink      title={'Stations'}  filename={"Stock-Basics_"+this.props.dodxl+".csv"} headers={this.headers} data={this.props.stocks}>Export Tab Data</CSVLink>    :''} </Tag>}
             sticky
           />
          </TabPane>

          <TabPane  tab={<span style={{fontWeight:'700'}}>A+ Stock Grades</span>}  key="2">
            <Table
              className="tb2"
            style={{width:'80%'}}
              columns={this.columns2}
              scroll={{ x:1000 }}
              dataSource={
                this.props.stocks
              }
              pagination={true}
              loading={loading}
              pagination={{ defaultPageSize: 40 }}
              // onChange={this.handleTableChange}
              bordered
              title={() => <Tag color="rgb(40 95 17)">  {this.props.stocks != 0? <CSVLink   filename={"A+Stock-Grades_"+this.props.dodxl+".csv"} headers={this.headers2} data={this.props.stocks}>Export Tab Data</CSVLink>    :''} </Tag>}
              sticky
            />
          </TabPane>

          <TabPane   tab={<span style={{fontWeight:'700'}}>Company Growth</span>}  key="3">
            <Table

              className="tb3"
              columns={this.columns3}
              scroll={{ x:3800   }}
              dataSource={
                this.props.stocks
              }
              pagination={true}
              loading={loading}
              // onChange={this.handleTableChange}
              pagination={{ defaultPageSize: 40 }}
              bordered
              title={() => <Tag color="rgb(40 95 17)">  {this.props.stocks != 0? <CSVLink   filename={"Company-Growth_"+this.props.dodxl+".csv"} headers={this.headers3} data={this.props.stocks}>Export Tab Data</CSVLink>    :''} </Tag>}
              sticky
              // onChange={this.handleTableChange}
            />
          </TabPane>

          <TabPane   tab={<span style={{fontWeight:'700'}}>Company Performance</span>}  key="4">
            <Table
              className="tb4"
              columns={this.columns4}
              style={{width:'70%'}}
          /*     scroll={{ x:1000,   y: 750  }} */
              dataSource={
                this.props.stocks
              }
              pagination={true}
              loading={loading}
              // onChange={this.handleTableChange}
              pagination={{ defaultPageSize: 40 }}
              bordered

              title={() => <Tag color="rgb(40 95 17)">  {this.props.stocks != 0? <CSVLink   filename={"Company-Performance_"+this.props.dodxl+".csv"} headers={this.headers4} data={this.props.stocks}>Export Tab Data</CSVLink>    :''} </Tag>}
              sticky
            />
          </TabPane>

          <TabPane    tab={<span style={{fontWeight:'700'}}>Financial Strength</span>} key="5">
            <Table
              columns={this.columns5}
              /* scroll={{  x:1000,  y: 750  }} */
              
              className="tb5"
              style={{width:'74%'}}
              dataSource={
                this.props.stocks
              }
              pagination={true}
              loading={loading}
              pagination={{ defaultPageSize: 40 }}
              bordered

              title={() => <Tag color="rgb(40 95 17)">  {this.props.stocks != 0? <CSVLink   filename={"Financial-Strength_"+this.props.dodxl+".csv"} headers={this.headers5} data={this.props.stocks}>Export Tab Data</CSVLink>    :''} </Tag>}
              sticky
              // onChange={this.handleTableChange}
            />
          </TabPane>

          <TabPane   tab={<span style={{fontWeight:'700'}}>Stock Performance</span>} key="6">
            
            <Table
              columns={this.columns6}
              style={{width:'70%'}}
              className="tb6"
              dataSource={
                this.props.stocks
              }
              pagination={true}
              loading={loading}
              pagination={{ defaultPageSize: 40 }}
              bordered
              title={() => <Tag color="rgb(40 95 17)">  {this.props.stocks != 0? <CSVLink   filename={"Stock-Performance_"+this.props.dodxl+".csv"} headers={this.headers6} data={this.props.stocks}>Export Tab Data</CSVLink>    :''} </Tag>}
              sticky
              // onChange={this.handleTableChange}
            />
          </TabPane>

          <TabPane    tab={<span style={{fontWeight:'700'}}>Valuation</span>} key="7">
            <Table
              columns={this.columns7}
             
              scroll={{ x:1500 }}
              className="tb7"
              dataSource={
                this.props.stocks
              }
              pagination={true}
              loading={loading}
              pagination={{ defaultPageSize: 40 }}
              bordered
              title={() => <Tag color="rgb(40 95 17)">  {this.props.stocks != 0? <CSVLink   filename={"Valuation_"+this.props.dodxl+".csv"} headers={this.headers7} data={this.props.stocks}>Export Tab Data</CSVLink>    :''} </Tag>}
              sticky
              // onChange={this.handleTableChange}
            />
          </TabPane>

          <TabPane   tab={<span style={{fontWeight:'700'}}>Earnings Surprises & Revisions</span>} key="8">
            <Table
              columns={this.columns8}
              style={{width:'70%'}}
              dataSource={
                this.props.stocks
              }
              className="tb8"
              pagination={true}
              loading={loading}
              pagination={{ defaultPageSize: 40 }}
              bordered
              title={() => <Tag color="rgb(40 95 17)">  {this.props.stocks != 0? <CSVLink   filename={"Earnings-Surprises-Revisions_"+this.props.dodxl+".csv"} headers={this.headers8} data={this.props.stocks}>Export Tab Data</CSVLink>    :''} </Tag>}
              sticky
              // onChange={this.handleTableChange}
            />
          </TabPane>
        </Tabs>
      </div>:''}
      
















  {this.state.showchart==true?

<div>

        <Tabs defaultActiveKey="1" style={{ marginBottom: 32 }}  >
          <TabPane tab="Tree Map " key="1">
          {this.state.showchart==true? <div>
           Showing top 1000 Market Capitalization  from the results

      
        </div>:''}     
          </TabPane>

       {/*    <TabPane tab="A+ Stock Grades" key="2">
            
          </TabPane>

          <TabPane tab="Company Growth" key="3">
            
          </TabPane>

          <TabPane tab="Company Performance" key="4">
             
          </TabPane>

          <TabPane tab="Financial Strength" key="5">
            
          </TabPane>

          <TabPane tab="Stock Performance " key="6">
            
          </TabPane>

          <TabPane tab="Valuation" key="7">
            
          </TabPane>

          <TabPane tab="Earnings Surprises & Revisions" key="8">
            
          </TabPane> */}
        </Tabs>
      </div>:''}    
     </div>
      
    );
  }
}








const mapStateToProps = (state) => ({
  datadic: state.datadic,
  apppath: state.apppath,
  stocks: state.stocks,
  record: state.record,
  recordtb: state.recordtb,
  tablehead: state.tablehead,
  auid: state.auid,
 // record: state.router.location.record,
});

const mapDispatchToProps = {
  activateDatadic,
  activatePath,
  activateStocks,
  activateRecord,
  activateTablehead,
  activateRecordtb,
  activateScreen,
};

const TableAPP = connect(mapStateToProps, mapDispatchToProps)(TableAPPClass);

export default TableAPP;
